module.exports = __webpack_public_path__ + "img/26-grand-wagoneer-l.214ad1d9.jpg";